import Vue from "vue";
// import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import ElementUI from "element-ui";
import "nprogress/nprogress.css";
import "element-ui/lib/theme-chalk/index.css";
import NavBar from "./components/NavBar.vue";
import NavBarv2 from "./components/NavBarv2.vue";
import FooterBar from "./components/Footer.vue";
import LoginAndFreeTrial from "./components/loginAndFreeTrial/LoginAndFreeTrial.vue";
import RequestDemo from "./components/requestDemo/RequestDemo.vue";
import AccountSettingNavBar from "./components/AccountSettingNavBar.vue";
import locale from "element-ui/lib/locale/lang/en";
import VeeValidate from "vee-validate";
import AppNavBar from "./components/admin/appNavBar/AppNavBar.vue";
import SentOrderUpdatePopUp from "./components/admin/inventory/sentOrder/sentOrderUpdatePopUp/SentOrderUpdatePopUp";
// import BaseAddProductsTable from "./components/baseAddProductsTable/BaseAddProductsTable";
// var echarts = require("../node_modules/echarts/");
// var echarts = require('echarts');
import VueCarousel from "vue-carousel";
import { ErrorBag } from "vee-validate";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import VueMeta from "vue-meta";
import VueDraggableResizable from "vue-draggable-resizable";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from 'v-mask'
// optionally import default styles
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { MessageBox } from "element-ui";
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import WebCam from "vue-web-cam";
Vue.use(WebCam);
// Inactivity logout code
const timeoutInMS = 1.44e+7; // 60 minutes -> 60 * 60 * 1000 = 3600000
let timeoutId;

function handleInactive() {
	// Here you want to logout a user and/or ping your token
	let isUserLoggedIn = localStorage.getItem("x-refresh-token");
	if (isUserLoggedIn) {
		showSessionPrompt();
		localStorage.setItem("is_inactive_user", true);
	}
}

let isUserLoggedIn = localStorage.getItem("x-refresh-token");
if (localStorage.getItem("is_inactive_user") && isUserLoggedIn) {
	showSessionPrompt();
}

function showSessionPrompt() {
	localStorage.setItem("is_inactive_user", true);
	MessageBox.alert(
		"Your session has expired due to inactivity. No worry, simply login again",
		"Session expired",
		{
			confirmButtonText: "OK",
			customClass: "session-alert-box",
			confirmButtonClass: "session-alert-btn",
			showClose: false,
			callback: (action) => {
				localStorage.setItem("is_inactive_user", false);
				const r_email = localStorage.getItem('r_email');
				localStorage.clear();
				if(r_email){
				localStorage.setItem('r_email', r_email);
				}
				setTimeout(() => {
					window.location.reload();
				}, 200);
			},
		}
	);
}

function startTimer() {
	// setTimeout returns an ID (can be used to start or clear a timer)
	timeoutId = setTimeout(handleInactive, timeoutInMS);
}

function resetTimer() {
	clearTimeout(timeoutId);
	startTimer();
}

function setupTimers() {
	document.addEventListener("keypress", resetTimer, false);
	document.addEventListener("mousemove", resetTimer, false);
	document.addEventListener("mousedown", resetTimer, false);
	document.addEventListener("touchmove", resetTimer, false);

	startTimer();
}

window.onload = setupTimers();

Vue.use(VueMeta, {
	refreshOnceOnNavigation: true,
});
Vue.use(VueGoogleMaps, {
	load: {
	  key: "AIzaSyAtwd_wH2a4Mx5MGFXh6puYt_OyBZvc-90",
	  libraries: "places" // necessary for places input
	}
  });
Vue.use(VueCarousel);
Vue.use(VueMask);
Vue.component("navbar", NavBar);
Vue.component("navbarv2", NavBarv2);
Vue.component("footerbar", FooterBar);
Vue.component("AccountSettingNavBar", AccountSettingNavBar);
Vue.component("LoginAndFreeTrial", LoginAndFreeTrial);
Vue.component("RequestDemo", RequestDemo);
Vue.component("AppNavBar", AppNavBar);
Vue.component("SentOrderUpdatePopUp", SentOrderUpdatePopUp);
// Vue.component("BaseAddProductsTable", BaseAddProductsTable);
Vue.use(ElementUI, { locale });
Vue.use(VeeValidate);
// Vue.use(echarts);
Vue.component("vue-draggable-resizable", VueDraggableResizable);

Vue.use(ElementUI);
Vue.config.productionTip = false;

Vue.directive("outside-click", {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			if (!(el == event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	unbind: function (el) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	},
});

VeeValidate.Validator.extend("verify_password", {
	getMessage: (field) =>
		`The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
	validate: (value) => {
		var strongRegex = new RegExp(
			"^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
		);
		return strongRegex.test(value);
	},
});

const requireComponent = require.context(
	// The relative path of the components folder
	"./components",
	// Whether or not to look in subfolders
	true,
	// The regular expression used to match base component filenames
	/Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
	// Get component config
	const componentConfig = requireComponent(fileName);

	// Get PascalCase name of component
	const componentName = upperFirst(
		camelCase(
			// Gets the file name regardless of folder depth
			fileName
				.split("/")
				.pop()
				.replace(/\.\w+$/, "")
		)
	);

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	);
});

new Vue({
    router,
    store,

    watch: {
		$route(to, from) {
			const canonicalTag = document.getElementById("page_canonical");
			const fullUrl = window.location.href;
			canonicalTag.setAttribute("href", fullUrl);
		},
	},

    vuetify,
    render: (h) => h(App)
}).$mount("#app");
